export default __webpack_public_path__ + "a4251755240f7d801e8c59f5a57b9321.png";